// extracted by mini-css-extract-plugin
module.exports = {"plotPath":"XvrU_Odj"};